import { DisplayCard, DisplayCardProps } from "./DisplayCard";

export interface OrgLike<TeamType, MembershipType, AthleteType> {
  id: string | number;
  name: string;
  teams: readonly TeamType[];
  memberships: readonly MembershipType[];
  athletes: readonly AthleteType[];
}

type OrgCardProps<T> = Omit<DisplayCardProps<T>, "primaryText" | "secondaryElement">;

export const OrgCard = <TeamType, MembershipType, AthleteType, T extends OrgLike<TeamType, MembershipType, AthleteType>>(
  props: OrgCardProps<T>
) => {
  const { element } = props;
  const primaryText = element.name;
  // TODO: get the actual number of people from the org
  const orgCompositionText = `${element.teams.length} teams, ${element.athletes.length} athletes, ${element.memberships.length} active memberships`;
  return <DisplayCard {...props} primaryText={primaryText} secondaryElement={orgCompositionText} />;
};
